<template>
    <div>
        <div class="goods-type">
            <img v-for="data in goodsType" :src="getShowUrl(data)" @click="selectGoodsType(data)" alt="">
        </div>
        <table class="basic" cellpadding="0" cellspacing="0">
            <tr>
                <td colspan="2">保额
                    <div class="amount">
                        <div v-for="data in amount"
                             :class="{'select':data.amount === totalInsuredAmount && !customerAmount,'unselect':data.amount !== totalInsuredAmount || customerAmount}"
                             @click="changeAmount(data.amount)">{{data.content}}
                        </div>
                        <div type="text" :class="{'select':customerAmount,'unselect':!customerAmount}"
                             @click="selectLimit" style="margin-right: 0">自定义
                        </div>
                    </div>
                </td>
            </tr>
            <tr v-show="customerAmount">
                <td></td>
                <td>
                    <valid
                            :content="insuredAmountInput"
                            :validator="validator.amount"
                            ref="valid0"
                    >
                        <input type="text" v-model="insuredAmountInput" :placeholder="amountPlaceHolder"
                               @change="getPayMoney"><span style="vertical-align: middle">万</span>
                    </valid>
                </td>
            </tr>
        </table>

        <div class="trans-title">
            运输信息
        </div>
        <table class="basic" cellpadding="0" cellspacing="0">
            <tr>
                <td>货物名称</td>
                <td>
                    <valid
                            :content="cargoName"
                            :max="50"
                            :min="1"
                            ref="valid1"
                    >
                        <input type="text" v-model="cargoName" placeholder="请输入货物名称" maxlength="50"
                               @change="getPayMoney">
                    </valid>
                </td>
            </tr>
           
            <tr>
                <td>车牌号码</td>
                <td>
                    <valid
                            :content="vehicleNo"
                            :validator="validator.vehicleNo"
                            ref="valid2"
                    >
                        <input type="text" v-model="vehicleNo" placeholder="请输入车牌号" maxlength="8" @change="getPayMoney">
                    </valid>
                </td>
            </tr>

            <tr>
                <td>起运时间(选填)</td>
                <td>
                       <!-- <valid
                            :content="startShipping"
                            :validator="validator.startShipping"
                            ref="valid7"
                    > -->
                        <input type="text" @click="showTime = true" class="address-select" v-model="startShipping"
                               readonly placeholder="请选择起运时间">
                       <!-- </valid> -->
                </td>
            </tr>

            <tr>
                <td>起始地省市区</td>
                <td>
                    <valid
                            :content="departure"
                            :validator="validator.departure"
                            ref="valid3"
                    >
                        <input type="text" @click="selectDeparture" class="address-select" v-model="departure" readonly
                               placeholder="请选择省市区">
                    </valid>
                </td>
            </tr>
            <tr>
                <td>中转地省市区(选填)</td>
                <td class="transit">
                    <input type="text" @click="selectTransitPlace" v-model="transit.context" readonly
                           placeholder="请选择省市区">
                    <div @click="clearTransitPlace">
                        <img :src="transit.imgUrl" :style="{'width':transit.size}" class="transit-img">
                    </div>
                </td>
            </tr>
            <tr>
                <td>目的地省市区</td>
                <td>
                    <valid
                            :content="destinationStr"
                            :validator="validator.destination"
                            ref="valid4"
                    >
                        <input type="text" @click="selectDestination" class="address-select" v-model="destinationStr"
                               readonly placeholder="请选择省市区">
                    </valid>
                </td>
            </tr>
             <tr>
                <td>司机姓名(选填)</td>
                <td>
                    <!-- <valid
                            :content="driverName"
                            :max="10"
                            :min="1"
                            ref="valid5"
                    > -->
                        <input type="text" v-model="driverName" placeholder="请输入司机姓名" maxlength="50">
                    <!-- </valid> -->
                </td>
            </tr>
            <tr>
                <td>司机手机号(选填)</td>
                <td>
                    <!-- <valid
                            :content="driverPhone"
                            :validator="validator.driverPhone"
                            :max="11"
                            :min="1"
                            ref="valid6"
                    > -->
                        <input type="number" v-model="driverPhone" placeholder="请输入司机手机号" maxlength="11">
                    <!-- </valid> -->
                </td>
            </tr>
            <tr>
                <td>保障起期</td>
                <td>30分钟后生效</td>
            </tr>
            <tr>
                <td>保障止期</td>
                <td>
                    {{endDate}}
                </td>
            </tr>
            <!--            <tr>-->
            <!--                <td>预估保费</td>-->
            <!--                <td>-->
            <!--                    <span v-show="Number(minPremium) !== Number(maxPremium)">-->
            <!--                        ￥{{minPremium}}~￥{{maxPremium}}-->
            <!--                    </span>-->
            <!--                    <span v-show="Number(minPremium) === Number(maxPremium)">-->
            <!--                        ￥{{minPremium}}-->
            <!--                    </span>-->
            <!--                </td>-->
            <!--            </tr>-->
            <tr>
                <td>预收保费</td>
                <td :class="{'red-text':Number(balance) < Number(payMoney)}">
                    ￥{{payMoney}}
                </td>
            </tr>
            <tr>
                <td>可用保费</td>
                <td>
                    ￥{{balance}}
                </td>
            </tr>
        </table>
        <van-popup v-model="showTime" position="bottom">
            <van-datetime-picker
                    v-model="currentDate"
                    title="起运时间"
                    type="date"
                    :min-date="minDate" 
                    :max-date="maxDate"
                    @confirm="confirmTime"
                    @cancel="cancelTime"
            />
        </van-popup>
    </div>
</template>

<script>
    import {Picker} from '../common/picker'
    import areaData from '../common/areaCode'
    import {goodsTypes, amounts} from "../common/commonData";
    import {formatDate, getUrlParams} from '../common/utils'
    import {mapGetters, mapState} from 'vuex'
    import Valid from "./Valid";
    import {isNum, isVehicleNo, isPhoneNum} from "../common/validaRule";

    const priceUrl = "/hsbxjj-excellent-driving-insurance/premium/calc";

    export default {
        name: "basicInfo",
        components: {Valid},
        data() {
            let date = new Date();
            date.setDate(date.getDate() + 14);
            let amountValid = (str) => {
                if (this.riskGroupInfoList[0].cargoType === '0' || this.riskGroupInfoList[0].cargoType === '-1') {
                    return isNum(str) && Number(str) >= 1 && Number(str) <= 300
                } else {
                    return isNum(str) && Number(str) >= 1 && Number(str) <= 100
                }
            };
            let destinationValid = (str) => {
                return str !== undefined && str !== ''
            };
            let departureValid = (str) => {
                window.console.log("校验333=========》", str)
                return str !== undefined && str !== ''
            };
            let startShippingValid = (str) => {
                window.console.log("校验=========》", str)
                return str !== undefined && str !== ''
            };
            return {
                //校验规则
                validator: {
                    amount: amountValid,
                    vehicleNo: isVehicleNo,
                    destination: destinationValid,
                    departure: departureValid,
                    driverPhone: isPhoneNum,
                    startShipping: startShippingValid,
                },
                customerAmount: false,
                endDate: formatDate(date, 'yyyy-MM-dd') + " 23:59:59",
                minDate:new Date(),
                maxDate:new Date(formatDate(date, 'yyyy/MM/dd')),
                goodsType: goodsTypes,
                //取消axios请求
                CancelToken: this.$http.CancelToken,
                cancel: null,
                showTime: false,
                currentDate: new Date()
            }
        },
        computed: {
            ...mapGetters('certificate', [
                'departure',
                'transit',
                'destinationStr',
                'amountPlaceHolder',
            ]),
            ...mapState('certificate', [
                'riskGroupInfoList',
                'driverInfoList',
                'totalInsuredAmount',
                'departureDate',
                'vno',
                'vc',
                'maxPremium',
                'minPremium',
                'payMoney',
                'balance',
                'mainOrderId',
            ]),
            //保额选择
            amount: {
                get() {
                    return amounts[this.riskGroupInfoList[0].cargoType]
                }
            },
            insuredAmountInput: {
                get() {
                    if (!isNaN(this.totalInsuredAmount) && this.totalInsuredAmount !== '') {
                        return parseInt(this.totalInsuredAmount / 10000);
                    } else {
                        //有规则校验,给非数值，标红
                        return this.totalInsuredAmount
                    }
                },
                set(val) {
                    if (!isNaN(val)) {
                        this.$store.commit('certificate/setAmount', parseInt(val * 10000));
                    } else {
                        //有规则校验,给非数值，标红
                        this.$store.commit('certificate/setAmount', val);
                    }
                }
            },
            cargoName: {
                get() {
                    return this.riskGroupInfoList[0].cargoName;
                },
                set(val) {
                    this.$store.commit('certificate/setGoodsName', val);
                }
            },
            driverName: {
                get() {
                    return this.driverInfoList[0].driverName;
                },
                set(val) {
                    this.$store.commit('certificate/setDriverName', val);
                }
            },
            startShipping: {
                get() {
                    return this.departureDate;
                },
                set(val) {
                    this.$store.commit('certificate/setDepartureDate', val);
                }
            },
            driverPhone: {
                get() {
                    return this.driverInfoList[0].driverPhone;
                },
                set(val) {
                    this.$store.commit('certificate/setDriverPhone', val);
                }
            },
            vehicleNo: {
                get() {
                    return this.vno;
                },
                set(val) {
                    val = val.toUpperCase();
                    this.$store.commit('certificate/setVehicleNo', val);
                }
            }
        },
        methods: {
            getShowUrl(data) {
                if (this.riskGroupInfoList[0].cargoType === data.id) {
                    return data.selectUrl;
                } else {
                    return data.url;
                }
            },
            selectGoodsType(data) {
                this.$store.commit('certificate/setGoodsType', data.id);
                this.$store.commit('certificate/setAmount', data.defaultAmount);
                this.customerAmount = false;
                this.getPayMoney();
            },
            changeAmount(amount) {
                this.$store.commit('certificate/setAmount', amount);
                this.customerAmount = false;
                this.getPayMoney();
            },
            selectLimit() {
                this.$store.commit('certificate/setAmount', '');
                this.customerAmount = true;
            },
            selectDeparture() {
                let vm = this;
                new Picker({
                    title: '请选择起运地',
                    data: areaData,
                    defaultValue: getDefaultArea(vm.departure),
                    keys: {
                        id: "id",
                        value: "name",
                        childData: "child"
                    },
                    callBack: function (arr) {
                        let place = {};
                        place.province = arr[0].name;
                        place.city = arr[1].name;
                        place.county = arr[2].name;

                        place.provinceCode = arr[0].id;
                        place.cityCode = arr[1].id;
                        place.countyCode = arr[2].id;

                        vm.$store.commit('certificate/setDeparture', place);
                        vm.$nextTick(() => {
                            vm.$refs.valid3.validation();
                        });
                        vm.getPayMoney();
                    }
                });
            },
            selectTransitPlace() {
                let vm = this;
                new Picker({
                    title: '请选择中转地',
                    data: areaData,
                    defaultValue: getDefaultArea(vm.transit.context),
                    keys: {
                        id: "id",
                        value: "name",
                        childData: "child"
                    },
                    callBack: function (arr) {
                        let place = {};
                        place.province = arr[0].name;
                        place.city = arr[1].name;
                        place.county = arr[2].name;

                        place.provinceCode = arr[0].id;
                        place.cityCode = arr[1].id;
                        place.countyCode = arr[2].id;

                        vm.$store.commit('certificate/setTransit', place);
                        vm.getPayMoney();
                    }
                });
            },
            clearTransitPlace() {
                //如果有中转地，则清空选择
                if (this.transit.context) {
                    let place = {
                        province: '',
                        city: '',
                        county: '',
                        provinceCode: '',
                        cityCode: '',
                        countyCode: ''
                    };
                    this.$store.commit('certificate/setTransit', place);
                } else {
                    //如果没用，则触发选择
                    this.selectTransitPlace();
                }
            },
            selectDestination() {
                let vm = this;
                new Picker({
                    title: '请选择目的地',
                    data: areaData,
                    defaultValue: getDefaultArea(vm.destination),
                    keys: {
                        id: "id",
                        value: "name",
                        childData: "child"
                    },
                    callBack: function (arr) {
                        let place = {};
                        place.province = arr[0].name;
                        place.city = arr[1].name;
                        place.county = arr[2].name;

                        place.provinceCode = arr[0].id;
                        place.cityCode = arr[1].id;
                        place.countyCode = arr[2].id;

                        vm.$store.commit('certificate/setDestination', place);
                        vm.$nextTick(() => {
                            vm.$refs.valid4.validation();
                        });
                        vm.getPayMoney();
                    }
                });
            },
            getPayMoney() {
                let data = {};
                //价格只和保额和货物类型有关
                //其他字段预留
                data.totalInsuredAmount = this.totalInsuredAmount;
                // data.vno = this.vno;
                // data.vc = this.vc;
                data.startCode = this.riskGroupInfoList[0].carriageStartPlace.countyCode;
                data.transferCode = this.riskGroupInfoList[0].transferPlace.countyCode;
                data.endCode = this.riskGroupInfoList[0].destination.countyCode;
                data.cargoType = this.riskGroupInfoList[0].cargoType;
                data.mainOrderId = this.mainOrderId;
                //startTime没传
                //校验是否非空(保额和货物类型不可能为空)
                // let flag = false;
                // for (let p in data){
                //     if (!data[p]){
                //         flag = true;
                //     }
                // }
                // if (flag){
                //     //data有空，不触发查询
                //     return;
                // }
                if (isNaN(data.totalInsuredAmount)) {
                    //自定义保额为非数值，不触发查询
                    return;
                }
                //如果之前的接口还未返回
                if (this.cancel) {
                    this.cancel();
                    this.cancel = null;
                }
                this.$http.post(priceUrl, data, {
                    cancelToken: new this.CancelToken((c) => {
                        this.cancel = c
                    })
                }).then(res => {
                    if (res.data.flag) {
                        this.$store.commit('certificate/setPayMoney', res.data.data.payPremium);
                        this.$store.commit('certificate/setMaxMoney', res.data.data.maxPremium);
                        this.$store.commit('certificate/setMinMoney', res.data.data.minPremium);
                    }
                })
            },
            changeAmountStatus() {
                //常用投保方案回填,
                // 需要判断保额在自定义还是默认的框
                let flag = true;
                for (let i = 0; i < this.amount.length; i++) {
                    if (this.amount[i].amount === this.totalInsuredAmount) {
                        flag = false;
                    }
                }
                if (flag) {
                    //需要打开自定义
                    this.customerAmount = true;
                }
            },
            //数据校验接口
            validation() {
                let flag = false;
                for (let i = 0; i < 5; i++) {
                    if (this.$refs['valid' + i].validation()) {
                        flag = true;
                    }
                }
                return flag;
            },
            cancelTime() {
                this.showTime = false;
            },
            confirmTime(time) {
                let value = formatDate(time, 'yyyy-MM-dd');
                this.$store.commit('certificate/setDepartureDate', value);
                this.showTime = false;
            },
        },
        mounted() {
            //初始化查询一次价格
            this.getPayMoney();
            //初始化可用保费
            if (getUrlParams().params) {
                let params = JSON.parse(decodeURIComponent(getUrlParams().params));
                this.$store.commit('certificate/setBalance', params.balance);
            }
        }
    }

    function getDefaultArea(area) {
        if (!area) {
            area = ""
        }
        return area.replace(/-/g, " ");
    }
</script>

<style scoped lang="scss">
    .trans-title {
        height: 12vw;
        padding-left: 13.33vw;
        margin-top: 2.67vw;
        line-height: 12vw;
        font-size: 4.27vw;
        font-weight: bold;
        text-align: left;
        background: url(../assets/transit.png) no-repeat 5.33vw center #ffffff;
        background-size: 5.33vw;
    }

    .goods-type {
        display: flex;
        margin-top: 2.67vw;
        padding: 4vw 5.33vw;
        justify-content: space-around;
        background: #ffffff;
        border-bottom: .27vw solid #f5f5f9;

        img {
            height: 16vw;
        }
    }

    .question-img {
        width: 5.53vw;
        margin-left: 1.33vw;
        vertical-align: middle;
    }

    .quota-service {
        height: 13.33vw;
        line-height: 13.33vw;
        text-align: left;
        background: url(../assets/switch-bar-1.png) no-repeat right 5.33vw center #ffffff;
        background-size: 12vw;
    }

    .same {
        background: url(../assets/switch-bar-2.png) no-repeat right 5.33vw center #ffffff;
        background-size: 12vw;
    }

    .base-table {
        width: 100%;
        background: #ffffff;

        tr {
            height: 13.33vw;
            line-height: 13.33vw;

            td {
                border-bottom: .27vw solid #f5f5f9;
            }

            td:nth-child(1) {
                padding-left: 5.33vw;
                text-align: left;
                color: #333333;
            }

            td:nth-child(2) {
                padding-right: 5.33vw;
                text-align: right;
                color: #666666;
            }
        }
    }

    .basic-select {
        display: inline-block;
        width: 17.33vw;
        height: 8vw;
        margin-right: 2.67vw;
        line-height: 8vw;
        text-align: center;
        vertical-align: middle;
        border-radius: 4vw;
    }

    .basic {
        .amount {
            float: right;
            padding-right: 5.33vw;

            .limit {
                width: 16vw;
                padding-right: 4.56vw;
                text-align: center;
                background: url(../assets/down.png) no-repeat right center;
                background-size: 2.67vw;
            }

            .select {
                color: #3385ff;
                background: #dceaff;
                border: .27vw solid #3385ff;
                @extend .basic-select
            }

            .unselect {
                color: #999999;
                background: #ffffff;
                border: .27vw solid #cccccc;
                @extend .basic-select
            }

            &:after {
                clear: both;
            }
        }

        .vehicle-no {
            width: 26.67vw;
        }

        .question-img {
            width: 5.53vw;
            margin-left: 1.33vw;
            vertical-align: middle;
        }

        .tips {
            position: absolute;
            width: 90vw;
            padding: 2vw 4.1vw;
            line-height: 5.07vw;
            background: #ffffff;
            word-break: break-all;
            box-shadow: 0 0 2.27vw #99c2ff40;
            z-index: 1;
        }

        .count {
            /*width: 63vw;*/
            color: #666666;
        }

        .address-select {
            max-width: 72.8vw;
            padding-right: 4.53vw;
            background: url(../assets/down.png) no-repeat right center;
            background-size: 2.67vw;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .transit {
            display: flex;
            max-width: 72.8vw;
            justify-content: flex-end;
            align-items: center;

            input {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            div {
                width: 4.53vw;

                img {
                    vertical-align: middle;
                }
            }
        }

        @extend .base-table
    }

    .valid-input {
        position: relative;
        /*line-height: 13.33vw;*/
        img {
            width: 4.53vw;
            margin: 0 1vw 0 1.33vw;
            vertical-align: middle;
        }

        .error {
            color: #ff4b33;

            &::placeholder {
                color: #ff4b33;
            }

            &:-moz-placeholder {
                color: #ff4b33;
            }

            &::-webkit-input-placeholder {
                color: #ff4b33;
            }

            &:-ms-input-placeholder {
                color: #ff4b33;
            }
        }
    }

    .red-text {
        color: red !important;
    }
</style>